export default "__VITE_ASSET__60d3b10e__"